import { useState } from "react";
import { styles } from "../../styles";
import { Field, ErrorNote } from "../common";
import { adminSignIn } from "../../hooks/useAuth";

export function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setError(null);
    if (!email.trim() || !password) {
      setError("Enter your email and password.");
      return;
    }
    setBusy(true);
    try {
      await adminSignIn(email.trim(), password);
    } catch {
      // Firebase auth errors are deliberately generic to avoid account probing.
      setError("That email and password did not match. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={styles.authWrap} className="fade">
      <div style={styles.authCard}>
        <h1 style={{ ...styles.cardTitle, fontSize: 24 }}>Shop sign in</h1>
        <p style={styles.sub}>This area is for shop staff. Sign in to manage the calendar.</p>
        {error && <ErrorNote>{error}</ErrorNote>}
        <form onSubmit={(e) => { e.preventDefault(); void submit(); }}>
          <Field label="Email" value={email} onChange={setEmail} type="email" autoComplete="email" placeholder="you@shop.com" />
          <Field label="Password" value={password} onChange={setPassword} type="password" autoComplete="current-password" />
          <button className="primary" style={styles.primary} type="submit" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
